{
    "name": "app",
    "version": "1.0.13",
    "scripts": {
        "ng": "ng",
        "start": "ng serve --port 6200",
        "build": "ng build",
        "buildForTeamcity": "ng build --configuration %ENVIRONMENT%",
        "watch": "ng build --watch --configuration dev",
        "test": "ng test",
        "lint": "cross-env NODE_OPTIONS=--max-old-space-size=8192 ng lint",
        "i18n:extract:all": "npm run i18n:extract && npm run i18n:extract:tools && npm run i18n:extract:settings-menu && npm run i18n:extract:table && npm run i18n:extract:avatar",
        "i18n:extract": "ngx-translate-extract -i ./src/app -o ./src/assets/i18n/en.json --sort -f json --clean",
        "i18n:extract:tools": "ngx-translate-extract -i ./src/sb-tools -o ./src/sb-tools/assets/i18n/en.json --sort -f json --clean",
        "i18n:extract:settings-menu": "ngx-translate-extract -i ./src/sb-modules/Frontend-Settings-Menu-Module -o ./src/sb-modules/Frontend-Settings-Menu-Module/assets/i18n/en.json --sort -f json --clean",
        "i18n:extract:table": "ngx-translate-extract -i ./src/sb-modules/Frontend-Table-Module -o ./src/sb-modules/Frontend-Table-Module/assets/i18n/en.json --sort -f json --clean",
        "i18n:extract:avatar": "ngx-translate-extract -i ./src/sb-modules/Frontend-User-Avatar-Module -o ./src/sb-modules/Frontend-User-Avatar-Module/assets/i18n/en.json --sort -f json --clean",
        "prepare": "husky install",
        "prettier": "npx prettier --write ."
    },
    "private": true,
    "dependencies": {
        "@ali-hm/angular-tree-component": "^12.0.5",
        "@angular/animations": "~20.3.1",
        "@angular/common": "~20.3.1",
        "@angular/compiler": "~20.3.1",
        "@angular/core": "~20.3.1",
        "@angular/forms": "~20.3.1",
        "@angular/platform-browser": "~20.3.1",
        "@angular/platform-browser-dynamic": "~20.3.1",
        "@angular/router": "~20.3.1",
        "@ctrl/ngx-emoji-mart": "^7.1.0",
        "@fortawesome/fontawesome-free": "^7.0.1",
        "@jonyadamit/ngx-qrcode-ivy": "^16.0.0",
        "@microsoft/applicationinsights-web": "^2.8.4",
        "@ng-select/ng-select": "^12.0.0",
        "@ngx-translate/core": "^17.0.0",
        "angular2-notifications": "^16.0.1",
        "bootstrap": "^5.1.3",
        "chart.js": "^4.4.7",
        "chroma-js": "^2.4.2",
        "file-saver": "^2.0.5",
        "intl-tel-input": "^25.10.10",
        "jquery": "^3.6.0",
        "jspdf": "^3.0.3",
        "jspdf-autotable": "^5.0.2",
        "moment": "^2.29.1",
        "ng12-ace-editor": "^0.0.1",
        "ng2-charts": "^8.0.0",
        "ngx-avatars": "~1.8.0",
        "ngx-bootstrap": "^12.0.0",
        "ngx-clipboard": "^15.0.1",
        "ngx-color-picker": "^17.0.0",
        "ngx-doc-viewer": "^15.0.1",
        "ngx-drag-drop": "^18.0.2",
        "ngx-dropzone-wrapper": "^17.0.0",
        "ngx-image-cropper": "^6.0.1",
        "ngx-linky": "^4.0.0",
        "ngx-mask": "^13.1.11",
        "ngx-quill": "^26.0.8",
        "ngx-summernote": "~1.0.0",
        "ngx-translate-multi-http-loader": "^7.0.5",
        "ngx-ui-switch": "^15.0.0",
        "prettier": "3.3.3",
        "prettier-eslint": "^16.1.2",
        "quill": "^2.0.2",
        "quill-image-resize": "^3.0.9",
        "rxjs": "~7.5.2",
        "summernote": "^0.9.1",
        "tslib": "^2.3.1",
        "vanilla-js-wheel-zoom": "^6.13.0",
        "xlsx": "^0.18.5",
        "zone.js": "~0.15.1"
    },
    "devDependencies": {
        "@angular-devkit/core": "^20.3.2",
        "@angular-devkit/schematics": "^20.3.2",
        "@angular-eslint/builder": "^20.3.0",
        "@angular-eslint/eslint-plugin": "^20.3.0",
        "@angular-eslint/eslint-plugin-template": "^20.3.0",
        "@angular-eslint/schematics": "^20.3.0",
        "@angular-eslint/template-parser": "^20.3.0",
        "@angular/build": "^20.3.2",
        "@angular/cli": "~20.3.2",
        "@angular/compiler-cli": "~20.3.1",
        "@types/jasmine": "~3.8.0",
        "@types/jquery": "^3.5.6",
        "@types/node": "^12.11.1",
        "@typescript-eslint/eslint-plugin": "^8.44.0",
        "@typescript-eslint/parser": "^8.44.0",
        "@typescript-eslint/utils": "^7.16.1",
        "@vendure/ngx-translate-extract": "^10.1.3",
        "cross-env": "^7.0.3",
        "eslint": "^8.57.1",
        "eslint-config-prettier": "^10.0.1",
        "eslint-plugin-import": "^2.25.4",
        "eslint-plugin-jasmine": "^4.1.3",
        "eslint-plugin-jsdoc": "^37.6.1",
        "eslint-plugin-prettier": "^5.2.3",
        "husky": "^8.0.3",
        "jasmine-core": "~3.8.0",
        "karma": "~6.3.0",
        "karma-chrome-launcher": "~3.1.0",
        "karma-coverage": "~2.1.0",
        "karma-jasmine": "~4.0.1",
        "karma-jasmine-html-reporter": "~1.7.0",
        "typescript": "^5.9.2"
    }
}
